import classNames from 'classnames';
import { memo } from 'react';

import { FileStatusPanelItem, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { SHARED_PANEL_ITEM_CLASS_NAMES } from '../../constants/ClassNames';
import { getSubtitleWithProgress } from '../../utils';
import { FileStatusThumbnail } from './FileStatusThumbnail';
import { type FileTrackingItem } from './FileStatusTrackingPanel';

export type FileStatusPanelListItemCompletedProps = {
  item: FileTrackingItem;
};

export const FileStatusTrackingPanelListItemCompleted = memo(
  ({
    item: { ext, onRowClick, previewLoader, avatar, title, thumbnailSource, sizeInBytes, subtitle, status },
  }: FileStatusPanelListItemCompletedProps) => {
    return (
      <FileStatusPanelItem
        avatar={avatar ?? <FileStatusThumbnail ext={ext} status={status} thumbnailSource={thumbnailSource} />}
        buttons={null}
        className={classNames(
          'opacity-60',
          SHARED_PANEL_ITEM_CLASS_NAMES,
          !!onRowClick && 'cursor-pointer hover:bg-grey-3',
        )}
        onClick={onRowClick}
        previewLoader={previewLoader}
        subtitle={
          <FileStatusSubtitle className="truncate">
            {subtitle ?? getSubtitleWithProgress({ sizeInBytes, title: 'Completed', uploadedBytes: sizeInBytes })}
          </FileStatusSubtitle>
        }
        title={<FileStatusTitle className="text-12">{title}</FileStatusTitle>}
      />
    );
  },
);

FileStatusTrackingPanelListItemCompleted.displayName = 'FileStatusTrackingPanelListItemCompleted';
